import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { UserRole } from "../../types/roles";

function GXMAdminGated({ children }) {
  const { role, id } = useSelector((state) => state.login);
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect if user is logged in and not GXM_ADMIN or SUPER_ADMIN
    // If user is not logged in, let the auth system handle it
    if (
      id &&
      role &&
      role !== UserRole.GXM_ADMIN &&
      role !== UserRole.SUPER_ADMIN
    ) {
      navigate("/forbidden");
    }
  }, [id, role, navigate]);

  // Don't render children if user is logged in but not GXM_ADMIN or SUPER_ADMIN
  if (
    id &&
    role &&
    role !== UserRole.GXM_ADMIN &&
    role !== UserRole.SUPER_ADMIN
  ) {
    return null;
  }

  // If user is not logged in yet, don't render (auth system will handle)
  if (!id) {
    return null;
  }

  return children;
}

export default GXMAdminGated;
